/* Bondel Options v1 — 2026-09-04 (Vitor). Native replacement for the Globo Product Options
   app block on the non-Studio product pages. Zero app dependency.

   WHAT IT DOES
   1. Renders "How many pets/people" pills + "Notes for our artist" + optional extras
      (HQ digital copy, Skip the line) inside the product page.
   2. Writes the SAME line-item properties Globo wrote, so Notion / bondel-automations /
      fulfillment keep reading exactly what they read today:
        properties[Pets we will draw (all included in price)] = "3 Pets"   (people pages: "People we will draw (all included in price)" = "3 People")
        properties[Drawing notes] = "..."
      plus hidden (underscore) properties: _bondel_group, _bondel_options=v1
   3. Price for 2+ pets: adds the existing helper product variant ("How many pets would you
      like us to portray?" › "3 Pets" $40) as a SEPARATE line, tagged _bondel_group=<same id>,
      _bondel_addon=pets. Same for extras (existing products).
      Flow on Add to cart (capture-phase click, fires BEFORE the theme's own handler):
        validate → POST /cart/add.js (add-ons) → re-dispatch click → theme adds the canvas
        with its normal AJAX path → cart drawer opens with all lines.
      If the theme's add fails → we remove the add-ons we just added (no orphans).
   4. Cart guard: removing the canvas line removes its add-ons; changing the canvas quantity
      syncs the pets add-on quantity.

   ROLLBACK: put the Globo block back in the template and delete the code block. Nothing else
   is touched (no theme.js / product.liquid edits). */
(function () {
  'use strict';
  if (window.__bondelOptionsLoaded) return;
  window.__bondelOptionsLoaded = true;

  var CFG = {
    pets: {
      prop: 'Pets we will draw (all included in price)',
      legend: 'How many pets should we paint?',
      unit: ['pet', 'pets'], propUnit: ['Pet', 'Pets'],
      max: 5,
      help: 'All pets go on the <b>same canvas</b>. Want separate canvases? Add each portrait to the cart on its own.',
      addon: { 2: { id: 45681838293219, price: 20 }, 3: { id: 45681838325987, price: 40 }, 4: { id: 45681838358755, price: 50 }, 5: { id: 45978982809827, price: 60 } }
    },
    people: {
      prop: 'People we will draw (all included in price)',
      legend: 'How many characters (people or pets) should we paint?',
      unit: ['character', 'characters'], propUnit: ['People', 'People'],
      max: 6,
      help: 'Everyone goes on the <b>same canvas</b>. Want separate canvases? Add each portrait to the cart on its own.',
      addon: { 2: { id: 47190456238307, price: 20 }, 3: { id: 47190456271075, price: 40 }, 4: { id: 47190456303843, price: 50 }, 5: { id: 47190456336611, price: 60 }, 6: { id: 47190456369379, price: 70 } }
    }
  };
  var EXTRAS = {
    digital: { id: 47085732757731, price: 9.99, title: 'HQ digital copy of your portrait', sub: 'The full-resolution file of your finished painting, emailed to you. Print it, share it, keep it forever.', badge: 'Most added' },
    priority: { id: 46201498501347, price: 14.99, title: 'Skip the line', sub: 'Your proof in 24 business hours instead of 2 days. We start on yours first.' }
  };
  var NOTES_MAX = 500;

  function money(n) { return '$' + n.toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function log() { try { if (window.console) console.log.apply(console, ['[bondel-options]'].concat([].slice.call(arguments))); } catch (e) {} }

  // ── Cart helpers (Shopify AJAX API) ──
  function cartAdd(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw new Error(j.description || j.message || ('cart/add ' + r.status)); } return j; }); });
  }
  function cartChange(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); });
  }
  function cartGet() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refreshDrawer() {
    try { var ci = document.querySelector('cart-items'); if (ci && typeof ci.getCart === 'function') { ci.getCart(); return; } } catch (e) {}
  }

  // ── Widget ──
  function init(root) {
    if (root.__bondelInit) return; root.__bondelInit = true;
    var kind = (root.getAttribute('data-kind') || 'pets').toLowerCase();
    var cfg = CFG[kind] || CFG.pets;
    var showExtras = root.getAttribute('data-extras') !== 'off';
    var defaultN = parseInt(root.getAttribute('data-default') || '0', 10) || 0; // 0 = customer must choose (like Globo)

    var section = root.closest('[data-section-id]') || root.closest('.product__wrapper') || document;
    var form = section.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]') || document.querySelector('form.product-form');
    if (!form) { log('no product form found — widget inactive'); return; }
    var formId = form.getAttribute('id');
    var atc = section.querySelector('[data-add-to-cart]') || document.querySelector('[data-add-to-cart]');

    var state = { n: defaultN, notes: '', extras: {}, groupId: '', pendingKeys: [] };

    // markup
    var pills = '';
    for (var i = 1; i <= cfg.max; i++) {
      var add = cfg.addon[i];
      pills += '<button type="button" class="bondel-opt__pill" data-n="' + i + '" aria-pressed="' + (i === defaultN ? 'true' : 'false') + '">' +
        i + ' ' + (i === 1 ? cfg.unit[0] : cfg.unit[1]) +
        '<span class="bondel-opt__sub">' + (add ? '+$' + add.price : 'included') + '</span></button>';
    }
    var extrasHtml = '';
    if (showExtras) {
      extrasHtml = '<div class="bondel-opt__extras">';
      Object.keys(EXTRAS).forEach(function (k) {
        var x = EXTRAS[k];
        extrasHtml += '<button type="button" class="bondel-opt__extra" data-extra="' + k + '" aria-pressed="false">' +
          '<span class="bondel-opt__cb">&#10003;</span>' +
          '<span class="bondel-opt__tx"><b>' + esc(x.title) + (x.badge ? ' <span class="bondel-opt__badge">' + esc(x.badge) + '</span>' : '') + '</b><span>' + esc(x.sub) + '</span></span>' +
          '<span class="bondel-opt__pr">+' + money(x.price) + '</span></button>';
      });
      extrasHtml += '</div>';
    }
    root.innerHTML =
      '<div class="bondel-opt__legend">' + esc(cfg.legend) + '<span class="bondel-opt__req" aria-hidden="true">*</span> <small data-sel-label></small></div>' +
      '<div class="bondel-opt__pills" role="group" aria-label="' + esc(cfg.legend) + '">' + pills + '</div>' +
      '<p class="bondel-opt__help">' + cfg.help + '</p>' +
      '<div class="bondel-opt__total" data-total></div>' +
      '<label class="bondel-opt__notes-lbl" for="bondel-notes-' + kind + '">Notes for our artist <span>(optional)</span></label>' +
      '<textarea class="bondel-opt__notes" id="bondel-notes-' + kind + '" maxlength="' + NOTES_MAX + '" placeholder="Background colors, your pet\'s name, anything we should know."></textarea>' +
      '<div class="bondel-opt__counter"><span data-cnt>0</span>/' + NOTES_MAX + '</div>' +
      extrasHtml +
      '<div class="bondel-opt__err" role="alert" data-err></div>';

    // hidden inputs (associated to the theme's product form via the form= attribute, like the theme does)
    function hidden(name) {
      var el = document.createElement('input'); el.type = 'hidden'; el.name = name; if (formId) el.setAttribute('form', formId); root.appendChild(el); return el;
    }
    var inCount = hidden('properties[' + cfg.prop + ']');
    var inNotes = hidden('properties[Drawing notes]');
    var inGroup = hidden('properties[_bondel_group]');
    var inVer = hidden('properties[_bondel_options]'); inVer.value = 'v1';

    var errEl = root.querySelector('[data-err]');
    function showErr(msg) { errEl.textContent = msg; errEl.classList.add('is-visible'); }
    function hideErr() { errEl.classList.remove('is-visible'); }

    function sync() {
      root.querySelectorAll('.bondel-opt__pill').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-n'), 10) === state.n)); });
      root.querySelectorAll('.bondel-opt__extra').forEach(function (b) { b.setAttribute('aria-pressed', String(!!state.extras[b.getAttribute('data-extra')])); });
      var lbl = root.querySelector('[data-sel-label]');
      lbl.textContent = state.n ? (state.n + ' ' + (state.n === 1 ? cfg.unit[0] : cfg.unit[1])) : '';
      inCount.value = state.n ? (state.n + ' ' + (state.n === 1 ? cfg.propUnit[0] : cfg.propUnit[1])) : '';
      inNotes.value = state.notes.trim();
      inNotes.disabled = !inNotes.value; // don't send an empty property
      var extra = 0; var parts = [];
      if (state.n >= 2 && cfg.addon[state.n]) { extra += cfg.addon[state.n].price; parts.push('+' + money(cfg.addon[state.n].price) + ' for ' + state.n + ' ' + cfg.unit[1]); }
      Object.keys(state.extras).forEach(function (k) { if (state.extras[k]) { extra += EXTRAS[k].price; parts.push('+' + money(EXTRAS[k].price) + ' ' + EXTRAS[k].title.toLowerCase()); } });
      root.querySelector('[data-total]').textContent = parts.length ? parts.join(' · ') + ' (added at checkout)' : '';
    }

    root.addEventListener('click', function (e) {
      var pill = e.target.closest('.bondel-opt__pill');
      if (pill) { state.n = parseInt(pill.getAttribute('data-n'), 10); hideErr(); sync(); return; }
      var ex = e.target.closest('.bondel-opt__extra');
      if (ex) { var k = ex.getAttribute('data-extra'); state.extras[k] = !state.extras[k]; sync(); }
    });
    var ta = root.querySelector('textarea');
    ta.addEventListener('input', function () { state.notes = ta.value.slice(0, NOTES_MAX); root.querySelector('[data-cnt]').textContent = state.notes.length; sync(); });
    sync();

    // ── Add-to-cart interception (capture phase → runs before the theme's click handler) ──
    function mainQty() { var q = form.querySelector('[name="quantity"]') || section.querySelector('[name="quantity"]'); var n = q ? parseInt(q.value, 10) : 1; return (n > 0 ? n : 1); }
    function addonItems(groupId) {
      var items = []; var q = mainQty();
      if (state.n >= 2 && cfg.addon[state.n]) items.push({ id: cfg.addon[state.n].id, quantity: q, properties: { _bondel_group: groupId, _bondel_addon: kind } });
      Object.keys(state.extras).forEach(function (k) { if (state.extras[k]) items.push({ id: EXTRAS[k].id, quantity: 1, properties: { _bondel_group: groupId, _bondel_addon: k } }); });
      return items;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn !== atc) return;
      if (btn.__bondelPass) { btn.__bondelPass = false; return; } // second pass → let the theme add the canvas
      if (!state.n) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        document.querySelectorAll('[data-add-to-cart-bar]').forEach(function (b) { b.removeAttribute('disabled'); b.classList.remove('is-loading'); });
        showErr('Please tell us how many ' + cfg.unit[1] + ' we should paint.');
        try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
        return;
      }
      hideErr();
      state.groupId = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      inGroup.value = state.groupId; sync();
      var items = addonItems(state.groupId);
      if (!items.length) return; // 1 pet, no extras → nothing to add first, theme proceeds normally
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      btn.disabled = true; btn.classList.add('is-loading');
      cartAdd(items).then(function (res) {
        state.pendingKeys = (res.items || []).map(function (it) { return it.key; });
        log('add-ons added', state.pendingKeys);
        btn.disabled = false; btn.classList.remove('is-loading');
        btn.__bondelPass = true; btn.click();
      }).catch(function (err) {
        log('add-on add failed', err);
        btn.disabled = false; btn.classList.remove('is-loading');
        document.querySelectorAll('[data-add-to-cart-bar]').forEach(function (b) { b.removeAttribute('disabled'); b.classList.remove('is-loading'); });
        showErr('Something went wrong adding your options. Please try again — nothing was charged.');
      });
    }, true);

    // theme failed to add the canvas → remove the add-ons we just added (no orphans)
    document.addEventListener('theme:product:add-error', function (e) {
      if (!state.pendingKeys.length) return;
      var keys = state.pendingKeys.slice(); state.pendingKeys = [];
      (function next() { var k = keys.shift(); if (!k) { refreshDrawer(); return; } cartChange(k, 0).then(next, next); })();
    });
    document.addEventListener('theme:product:add', function () { state.pendingKeys = []; });
  }

  // ── Cart guard (runs on every page: drawer + /cart) ──
  function isAddon(it) { return !!(it.properties && it.properties._bondel_addon); }
  function groupOf(it) { return (it.properties && it.properties._bondel_group) || ''; }

  // removing a canvas line → remove its add-ons first, then let the theme remove the canvas
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-item-remove]');
    if (!btn || btn.__bondelPass) { if (btn) btn.__bondelPass = false; return; }
    var key = btn.getAttribute('data-id'); if (!key) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    cartGet().then(function (cart) {
      var me = (cart.items || []).filter(function (it) { return it.key === key; })[0];
      var g = me && !isAddon(me) ? groupOf(me) : '';
      var kids = g ? cart.items.filter(function (it) { return isAddon(it) && groupOf(it) === g; }) : [];
      (function next() { var k = kids.shift(); if (!k) { btn.__bondelPass = true; btn.click(); return; } cartChange(k.key, 0).then(next, next); })();
    }).catch(function () { btn.__bondelPass = true; btn.click(); });
  }, true);

  // after any cart change → orphans out, pets add-on quantity = canvas quantity
  var guarding = false;
  document.addEventListener('theme:cart:change', function () {
    if (guarding) return; guarding = true;
    cartGet().then(function (cart) {
      var items = cart.items || []; var ops = [];
      items.forEach(function (it) {
        if (!isAddon(it)) return;
        var g = groupOf(it); if (!g) return;
        var parent = items.filter(function (p) { return !isAddon(p) && groupOf(p) === g; })[0];
        if (!parent) ops.push([it.key, 0]);
        else if ((it.properties._bondel_addon === 'pets' || it.properties._bondel_addon === 'people') && it.quantity !== parent.quantity) ops.push([it.key, parent.quantity]);
      });
      (function next() { var op = ops.shift(); if (!op) { guarding = false; return; } cartChange(op[0], op[1]).then(function () { if (!ops.length) { refreshDrawer(); } next(); }, next); })();
      if (!ops.length) guarding = false;
    }).catch(function () { guarding = false; });
  });

  function boot() { document.querySelectorAll('[data-bondel-options]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
